import BatchFilesList from "./BatchFilesList"

export default BatchFilesList

